<script setup>
const props = defineProps({
  company: {
    type: Object,
    required: true,
  },
})

const user = useStrapiUser()
const { upload } = useUploadUtils()

const isProfessional = computed(() => user.value?.type === 'professional')

const address = computed(() => {
  if (!props.company) return null

  return `${props.company.address.address}, ${props.company.address.city}`
})

const companySize = computed(
  () =>
    props.company?.about?.info?.find((info) => info.title === 'FTE')?.content,
)

const vacanciesUrl = computed(() =>
  isProfessional.value
    ? `/recommendations/vacancies?company=${props.company.slug}`
    : `/vacancies?company=${props.company.slug}`,
)
</script>

<template>
  <div class="bg-primary pb-20 pt-[58px] md:pb-12 lg:pb-4 lg:pt-[68px]">
    <BaseContainer class="relative">
      <div class="flex flex-col items-center lg:flex-row">
        <figure
          class="relative mb-4 h-[80px] w-[80px] justify-self-center overflow-hidden rounded-lg bg-gray-200 lg:mb-0"
          :class="{
            'flex items-center bg-[#F8FAFC]': company && !company.logo,
          }"
        >
          <img
            v-if="company?.logo"
            :src="upload(company.logo, 'thumbnail')"
            alt=""
            class="absolute left-0 top-0 h-full w-full object-cover"
          />
          <img v-else class="mx-auto" :src="'/images/fallback.svg'" />
        </figure>
        <div v-if="company?.name" class="pl-0 pt-3 lg:pl-8">
          <h1
            class="text-center font-heading text-6xl font-black uppercase text-secondary lg:text-left lg:text-7xl"
          >
            {{ company?.name || '' }}
          </h1>
        </div>
      </div>

      <div
        class="mt-8 flex items-center justify-between md:px-0 md:py-0 lg:mt-12 lg:px-0"
      >
        <div class="flex flex-col gap-4 md:flex-row">
          <div class="flex items-center">
            <IconOffice class="mr-2 h-[24px] w-[24px] text-secondary" />
            <div v-if="address" class="text-base text-gray-800">
              {{ address }}
            </div>
          </div>

          <div v-if="companySize" class="flex items-center lg:ml-8">
            <IconGroup class="mr-2 h-[24px] w-[24px] text-secondary" />
            <div class="text-base text-gray-800">{{ companySize }}</div>
          </div>

          <div class="flex items-center lg:ml-8">
            <IconBriefcase class="mr-2 h-[24px] w-[24px] text-secondary" />
            <div class="text-base text-gray-800">
              <NuxtLink :to="vacanciesUrl" class="underline">
                {{ `${company.vacancies.length} vacatures` }}
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>
    </BaseContainer>
  </div>
</template>
